import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

// interface ToolbarProps {
//   setOpenLesson: () => void
//   setOpenWeek: () => void
// }

export const CreateToolbar = (props: any) => {
  const { closeDrawer } = props

  const RenderWithClose = () => (
    <Toolbar {...props}>
      <SaveButton label="SALVAR" redirect="list" submitOnEnter={true} />
      {closeDrawer}
    </Toolbar>
  )

  if(closeDrawer) return <RenderWithClose />

  return (
    <Toolbar {...props}>
      <SaveButton label="SALVAR" redirect="list" submitOnEnter={true} />
    </Toolbar>
  )
}
